module.exports = __webpack_public_path__ + "static/media/steps.333a3e84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/steps.png
// module id = 299
// module chunks = 0